import {
  absoluteImage,
  absoluteUrl,
  DEFAULT_SEO_PUBLISHER,
  stripHtml,
} from "../config/seo";

const truncate = (s: string, maxLen: number) => {
  const text = s.trim();
  if (!text) return "";
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}...`;
};

export const buildkalyanakalpataruDescription = (kalyanakalpataru: any) => {
  const html = kalyanakalpataru?.description ?? kalyanakalpataru?.intro ?? "";
  const text = stripHtml(html);
  return truncate(text, 160);
};

export const buildkalyanakalpataruKeywords = (kalyanakalpataru: any) => {
  const parts = [kalyanakalpataru?.author, kalyanakalpataru?.kalyanakalpataruLanguage, kalyanakalpataru?.name]
    .map((v: any) => (v ? String(v).trim() : ""))
    .filter(Boolean);

  const uniq: string[] = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (!uniq.some((x) => x.toLowerCase() === key)) uniq.push(p);
  }

  return uniq.join(", ");
};
export const buildkalyanakalpataruJsonLd = (kalyanakalpataru: any, canonicalPath: string) => {
  const url = absoluteUrl(canonicalPath);
  const seoImage = kalyanakalpataru?.ogImage || kalyanakalpataru?.kalyanakalpataruPath || "";
  const image = seoImage ? absoluteImage(seoImage) : "";
  const description = buildkalyanakalpataruDescription(kalyanakalpataru);
  const authorName = kalyanakalpataru?.author ? String(kalyanakalpataru.author).trim() : "";
  const name = kalyanakalpataru?.name ? String(kalyanakalpataru.name).trim() : "";
  const inLanguage = kalyanakalpataru?.kalyanakalpataruLanguage ? String(kalyanakalpataru.kalyanakalpataruLanguage).trim() : "";

  const jsonLd: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "kalyanakalpataru",
    name: name || undefined,
    url: url || undefined,
    ...(description ? { description } : {}),
    ...(image ? { image } : {}),
    ...(authorName ? { author: { "@type": "Person", name: authorName } } : {}),
    ...(inLanguage ? { inLanguage } : {}),
    publisher: { "@type": "Organization", name: DEFAULT_SEO_PUBLISHER },
  };

  // Remove undefined properties so schema is cleaner.
  for (const key of Object.keys(jsonLd)) {
    if (jsonLd[key] === undefined) delete jsonLd[key];
  }

  return jsonLd;
};

